import * as Mod1 from "./initializers/apply-details";
import * as Mod2 from "./lib/discourse-markdown/details";
import * as Mod3 from "./lib/rich-editor-extension";
const compatModules = {
  "initializers/apply-details": Mod1,
  "lib/discourse-markdown/details": Mod2,
  "lib/rich-editor-extension": Mod3,
};
export { compatModules };
export default compatModules;
